import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';

import styles from './OfferCardActiveWrapper.module.scss';

type OfferCardActiveWrapperProps = {
  children: React.ReactNode;
  active?: boolean;
  title?: string;
};

export const OfferCardActiveWrapper = (props: OfferCardActiveWrapperProps) => {
  const { children, active: isActive, title } = props;

  return (
    <Space direction="vertical">
      {isActive ? (
        <Card className={styles.active}>
          <Space
            size={4}
            className="h-color-L100"
          >
            <Text
              strong
              size={14}
            >
              {title}
            </Text>
          </Space>
        </Card>
      ) : null}
      {children}
    </Space>
  );
};
